import * as React from 'react'
import Paper from '@mui/material/Paper'
// import Table from '@mui/material/Table'
// import TableHead from '@mui/material/TableHead'
// import TableBody from '@mui/material/TableBody'
// import TableCell from '@mui/material/TableCell'
// import TableRow from '@mui/material/TableRow'
import { styled } from '@mui/material/styles'

// import EditIcon from '@mui/icons-material/EditOutlined'
// import DoneIcon from '@mui/icons-material/DoneAllTwoTone'
// import RevertIcon from '@mui/icons-material/NotInterestedOutlined'
// import IconButton from '@mui/material/IconButton'
// import Input from '@mui/material/Input'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Navigation from './Navigation'
import { Container } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
// import FormControlLabel from '@mui/material/FormControlLabel'
// import Radio from '@mui/material/Radio'
// import RadioGroup from '@mui/material/RadioGroup'

import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import SeasonAdd from './SeasonAdd'



// const CustomTableCell = ({ row, name, onChange }) => {
//   const { isEditMode } = row
//   return (
//     <TableCell align='left'>
//       {isEditMode ? (
//         name === 'gender' ? (
//           <RadioGroup
//             aria-label='gender'
//             defaultValue='women'
//             name='gender'
//             value={row[name] || null}
//             onChange={(e) => onChange(e, row)}
//           >
//             <FormControlLabel value='women' control={<Radio />} label='Nainen' />
//             <FormControlLabel value='men' control={<Radio />} label='Mies' />
//           </RadioGroup>
//         ) : (
//           <Input value={row[name]} name={name} onChange={(e) => onChange(e, row)} />
//         )
//       ) : (
//         row[name]
//       )}
//     </TableCell>
//   )
// }

const ThemeButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
}))

function SeasonsPage({ seasons, push, update }) {
  const [rows, setRows] = React.useState(seasons || [])
  // const [previous, setPrevious] = React.useState({})
  const [seasonInsertOpen, setSeasonInsertOpen] = React.useState(false)
  const [editorOpen, setEditorOpen] = React.useState(false)
  const [selectedSeason, setSelectedSeason] = React.useState(null)
  

  const dataGridColumns = [
    { field: 'name', headerName: 'Nimi', width: 250, editable: true },
    { field: 'key', headerName: 'Avain', width: 250, editable: false },
  ]

  const handleEditorClose = (content) => {
    if (content) {
      update('customers/lahiliiga/configs/seasons/' + selectedSeason.id, { regulations: content })
    }
    setEditorOpen(false)
  }

  // const onToggleEditMode = (id) => {
  //   setRows((state) => {
  //     return rows.map((row) => {
  //       if (row.id === id) {
  //         if (row.isEditMode) {
  //           const updateRow = { ...row }
  //           delete updateRow.isEditMode
  //           update('customers/lahiliiga/configs/leagues/' + id, updateRow)
  //         }
  //         return { ...row, isEditMode: !row.isEditMode }
  //       }
  //       return row
  //     })
  //   })
  // }

  const onCellEditCommit = (params) => {
    const key = params.key.trim().replaceAll('/','-').replaceAll(' ','-')
    const updateRow = { [params.field]: params.value, key }
    update('customers/lahiliiga/configs/seasons/' + params.id, updateRow)
  }

  React.useEffect(() => {
    setRows(seasons)
  }, [seasons])

  const addNewSeason = () => {
    setSeasonInsertOpen(true)
  }
  const closeSeasonAdd = () => {
    setSeasonInsertOpen(false)
  }

  return (
    <>
      <Box
        sx={{
          width: '100vw',
          minHeight: '100vh',
          height: '100%',
          bgcolor: 'background.default',
          pb: 10,
        }}
      >
        <Navigation />
        <Container style={{ marginTop: 20 }}>
          <Paper>
            <ThemeButton onClick={() => addNewSeason()}>
              <AddIcon />
              Lisää kausi
            </ThemeButton>

            <DataGrid
              autoHeight
              pagination
              rows={rows}
              columns={dataGridColumns}
              components={{ Toolbar: GridToolbar }}
              initialState={{
                pagination: {
                  pageSize: 25,
                },
              }}
              onCellEditCommit={onCellEditCommit}
            />

          </Paper>
        </Container>
      </Box>
      <SeasonAdd open={seasonInsertOpen} onClose={closeSeasonAdd} />
    </>
  )
}

const withSeasons = compose(
  firebaseConnect(() => [
    {
      path: 'customers/lahiliiga/configs/seasons',
    },
  ]),
  connect((state, props) => {
    if (state.firebase.ordered?.customers?.lahiliiga?.configs?.seasons) {
      return {
        seasons: state.firebase.ordered.customers.lahiliiga.configs.seasons.map((r) => {
          return { id: r.key, ...r.value }
        }),
        auth: state.firebase.auth,
        update: props.firebase.update,
        push: props.firebase.push,
        set: props.firebase.set,
      }
    } else {
      return {
        seasons: [],
        auth: state.firebase.auth,
        update: props.firebase.update,
        push: props.firebase.push,
        set: props.firebase.set,
      }
    }
  })
)

export default withSeasons(SeasonsPage)
